import { useEffect } from "react";

let lockCount = 0;
let originalOverflow = "";

/**
 * Locks body scroll while `active` is true. Refcounted so overlapping dialogs
 * cannot clobber each other, and the original overflow value is restored rather
 * than being reset to a hardcoded default.
 */
export function useScrollLock(active: boolean): void {
    useEffect(() => {
        if (!active) {
            return;
        }

        if (lockCount === 0) {
            originalOverflow = document.body.style.overflow;
            document.body.style.overflow = "hidden";
        }
        lockCount += 1;

        return () => {
            lockCount = Math.max(0, lockCount - 1);
            if (lockCount === 0) {
                document.body.style.overflow = originalOverflow;
            }
        };
    }, [active]);
}
